import React, { useState } from 'react';
import { ListGroup, Button } from 'react-bootstrap';
import { Pencil, XOctagon } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

import EditFormModal from '../EditFormModal';
import { deleteForm } from '../../services/project/formGroupService';
import { useUsers } from '../../context/UserContext';

const FormList = ({
  forms,
  selectedForm,
  setSelectedForm,
  setActiveTab,
  refetchForms = () => {},
}) => {
  
  const { isAdmin, hasPermission } = useUsers();
  const { projectId } = useParams();
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [editingForm, setEditingForm] = useState(null);

  const openRename = (form) => {
    setEditingForm(form);
    setShowRenameModal(true);
  };

  const closeRename = () => {
    setShowRenameModal(false);
    setEditingForm(null);
  };

  const handleDelete = async (form) => {
    if (!window.confirm(`Delete "${form.name}"?`)) return;
    try {
      const res = await deleteForm(projectId, form.id);
      if (!res?.success) {
        toast.error(res?.data?.errorMessage || 'Error deleting form.');
        return;
      }
      toast.success(res?.message || 'Form deleted');
      // If you deleted the selected form, clear selection
      if (selectedForm?.id === form.id) {
        setSelectedForm(null);
        setActiveTab(''); // or a default tab key if you have one
      }
      refetchForms();
    } catch (error) {
      console.error('Delete form error:', error);
      toast.error(error?.response?.data?.error || 'Something went wrong');
    }
  };

  return (
    <>
      <h4>Forms</h4>
      <ListGroup>
        {forms.map((f) => {
          const isActive = selectedForm?.id === f.id;
          return (
            <ListGroup.Item
              key={f.id}
              action
              onClick={() => {
                setSelectedForm(f);
                setActiveTab(f.id.toString());
              }}
              className={`${isActive ? 'active ' : ''}d-flex justify-content-between align-items-center`}
            >
              <div className="d-flex align-items-center">
                <span>{f.name}</span>
                {(f.condition && Object.keys(f.condition).length > 0) && (
                  <span className="badge bg-warning text-dark ms-2">⚡ Conditional</span>
                )}
              </div>
              {isAdmin && (
                <div className="d-flex align-items-center gap-2">
                  <Button
                    variant="link"
                    className={`p-0 ${isActive ? 'text-white' : ''}`}
                    title="Rename"
                    onClick={(e) => {
                      e.stopPropagation();
                      openRename(f);
                    }}
                  >
                    <Pencil />
                  </Button>
                  <Button
                    variant="link"
                    className={`p-0 ${isActive ? 'text-white' : ''}`}
                    title="Delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(f);
                    }}
                  >
                    <XOctagon />
                  </Button>
                </div>
              )}
            </ListGroup.Item>
          );
        })}
      </ListGroup>

      {showRenameModal && (
        <EditFormModal
          form={editingForm}
          show={showRenameModal}
          onClose={closeRename}
          refetch={refetchForms}
        />
      )}
    </>
  );
};

export default FormList;
